/* eslint-disable @typescript-eslint/no-unused-vars */
import {useNavigation, useRoute} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';

import {formatDateTo} from '../../../../common/utils/functions';
import {CategorieVoyage} from '../../../../data/types/interface/Assurance/AssuranceVoyage/devis';
import {StackParams} from '../../../../data/types/navigation';
import {VoyageServices} from '../../../../services/applicatif/voyages';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import Label from '../../../components/Label';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../../components/PageContainer';
import {Form} from './FormMobile';

type NavigationProps = StackNavigationProp<
  StackParams,
  'ModificationAssuranceVoyage'
>;

export const FModificationAssuranceVoyageForm = () => {
  const {goBack} = useNavigation<NavigationProps>();
  const {modificationContrat} = VoyageServices();
  const {listCategories: getListCategories} = VoyageServices();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const {params}: any = useRoute();

  const [postSucces, setPostSuccess] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [listCategories, setListCategories] = React.useState<
    Array<CategorieVoyage>
  >([]);

  const handleCancel = () => {
    goBack();
  };

  const handleGetListCagegories = async () => {
    setIsLoading(true);
    try {
      const res = await getListCategories();
      if (!res?.isError && res.data && Array.isArray(res.data)) {
        setListCategories(res.data);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setIsLoading(false);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmit = (response: any) => {
    console.log('submitted in index', response);

    setIsLoading(true);
    const dataToSend = {
      policyId: params?.policyId,
      message: params?.message,
      destination: params?.destination,
      policyNumber: params?.policyNumber,
      dateDebut: formatDateTo(response?.dateDebut, 'Date') as Date,
      dateFin: formatDateTo(response?.dateFin, 'Date') as Date,
      assure: [...response.assure],
    };

    modificationContrat({...dataToSend})
      .then(res => {
        console.log('res modification', res);
        if (!res.isError) {
          setPostSuccess(true);
        } else {
          setErrorMessage(
            res.details && typeof res.details == 'string'
              ? res.details
              : res.message,
          );
          setShowErrorModal(true);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  React.useEffect(() => {
    !listCategories.length && handleGetListCagegories();
  }, []);

  return (
    <View>
      <HeaderScreen
        title="Modification assurance voyage"
        type="retour"
        noBreadcrumb={false}
      />
      <PageContainer>
        {postSucces && (
          <ConfirmationModal
            title="Assurance Voyage"
            content="Votre modification a été prise en compte."
            btn1="OK"
            handleBtn1={goBack}
          />
        )}
        {showErrorModal && (
          <ConfirmationModal
            title="Erreur"
            content={errorMessage}
            btn1="OK"
            handleBtn1={() => setShowErrorModal(false)}
          />
        )}
        {/** Loading */}
        {IsLoading && <Loader />}
        {/** Header content */}
        {!IsLoading && !postSucces && !showErrorModal && (
          <View
            style={{
              marginHorizontal: 20,
              marginVertical: 20,
              paddingVertical: 20,
              paddingHorizontal: 10,
              borderRadius: 20,
              elevation: 4,
              backgroundColor: 'white',
            }}>
            <Label
              title={params?.destination}
              type="mainTitle"
              style={{marginBottom: 10, marginTop: 0}}
              textStyle={{marginTop: 0}}
            />
            <Label title={params?.policyNumber} />
          </View>
        )}
        {/** Form content */}
        {!postSucces && !IsLoading && !showErrorModal && (
          <Form
            data={params}
            onCancelForm={handleCancel}
            onSubmitForm={handleSubmit}
            listCategories={listCategories}
          />
        )}
      </PageContainer>
    </View>
  );
};

export const ModificationAssuranceVoyage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FModificationAssuranceVoyageForm);
